// extracted by mini-css-extract-plugin
export default {"detailContainer":"stockList_detailContainer__mjHZo"};